module.exports = __webpack_public_path__ + "static/media/checked.759d7ac8.png";